import { createReducer } from 'reduxsauce';
import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import { ConfigTypes } from '../actions/ConfigActions';
import { getLanguage } from './AppReducer';
import { getTargetCountryId } from '../selectors/TargetCountrySelector';

/* ------------- Initial Login State ------------- */
export const INITIAL_STATE = Immutable({
  error: '',
  fetching: false,
  config: null,
});

/* ------------- Reducers ------------- */
export const onRequest = (state) => state.merge({ fetching: true });
export const onConfigSuccess = (state, { config = null }) =>
  state.merge({
    fetching: false,
    config,
  });
export const onFailure = (state, { error }) =>
  state.merge({ fetching: false, error });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [ConfigTypes.GET_CONFIG_REQUEST]: onRequest,
  [ConfigTypes.GET_CONFIG_SUCCESS]: onConfigSuccess,
  [ConfigTypes.GET_CONFIG_FAILURE]: onFailure,
});

/* ------------- Selectors ------------- */
export const getError = (state) => state.configs.error;
export const isFetching = (state) => state.configs.fetching;
export const getConfig = (state) => state.configs.config;

// memoized
export const isLoaded = createSelector(getConfig, (config) => config !== null);

export const getVisaTypes = createSelector(
  [isLoaded, getConfig],
  (isLoaded, config) => (isLoaded ? config.visaTypes : [])
);
export const getVisaPurposes = createSelector(
  [isLoaded, getConfig],
  (isLoaded, config) => (isLoaded ? config.visaPurposes : [])
);
const sortFieldByLang = {
  en: 'nameLangDefault',
  fr: 'nameAltLangOne',
  de: 'nameAltLangTwo',
};
export const getCountries = createSelector(
  [isLoaded, getConfig, getLanguage],
  (isLoaded, config, lang) => {
    if (isLoaded) {
      const sortField = sortFieldByLang[lang] || 'nameLangDefault';
      return Array.from(config.countries).sort((a, b) =>
        a[sortField] > b[sortField] ? 1 : -1
      );
    }
    return [];
  }
);
export const getOccupations = createSelector(
  [isLoaded, getConfig],
  (isLoaded, config) => (isLoaded ? config.occupations : [])
);
export const getPassportTypes = createSelector(
  [isLoaded, getConfig],
  (isLoaded, config) => (isLoaded ? config.passportTypes : [])
);
export const getValidations = createSelector(
  [isLoaded, getConfig],
  (isLoaded, config) => (isLoaded ? config.formValidation : {})
);
export const getDiplomaticMission = createSelector(
  [isLoaded, getConfig],
  (isLoaded, config) => (isLoaded ? config.diplomaticMissions : [])
);
export const getPoes = createSelector(
  [isLoaded, getConfig, getTargetCountryId],
  (isLoaded, config, targetCountryId) => {
    if (!isLoaded) {
      return [];
    }
    const poes = config.poes || [];
    if (!targetCountryId) {
      return poes;
    }
    return poes.filter(poe => poe.countryId === targetCountryId);
  }
);

export const getDestinations = createSelector(
  [isLoaded, getConfig, getTargetCountryId],
  (isLoaded, config, targetCountryId) => {
    if (!isLoaded) {
      return [];
    }
    const destinations = config.destinations || [];
    if (!targetCountryId) {
      return destinations;
    }

    return destinations.filter(destination => destination.countryId === targetCountryId);
  }
);



// WEBPACK FOOTER //
// ./src/state/reducers/ConfigReducer.js